<phdsoft-sideboard [options]="optionsWindow" (cancel)="closeWindow()" class="consequence-map-window">
  <div content class="consequence-map-content" *ngIf="!isLoadingComponentData">
    <div class="consequence-map-container">
      <div class="consequence-map-sticky-tools">
        <div class="consequence-map-mode-toggle">
          <span class="mode-toggle-title">View</span>
          <label class="toggle-switch">
            <span class="mode-toggle-label" [class.active]="!isSectionMode">Region Mode</span>
            <input type="checkbox" [(ngModel)]="isSectionMode" (change)="toggleSectionMode(isSectionMode)">
            <span class="toggle-slider" aria-hidden="true"></span>
            <span class="mode-toggle-label" [class.active]="isSectionMode">Section Mode</span>
          </label>
        </div>

        <div class="consequence-map-search">
          <input
            type="text"
            class="search-input"
            placeholder="{{ isSectionMode ? 'Search sections...' : 'Search regions...' }}"
            [(ngModel)]="searchTerm"
            (input)="onSearchChange()"
          >
          <mat-icon class="search-icon">search</mat-icon>
        </div>
      </div>

      <ul *ngIf="!isSectionMode" class="consequence-map-list consequence-map-tree">
        <li 
          class="consequence-map-list-item region-item"
          [ngClass]="{ 'consequence-map-list-item-data-selected': region == currentSelectedItem }"
          [class.consequence-map-list-item-data-ancestor]="currentSelectedItem && currentSelectedItem !== region && currentSelectedItem.regionId === region.regionId"
          *ngFor="let region of filteredRegions"
        >
          <div 
            class="consequence-map-list-item-data explorer-row region-row"
            (click)="handleClickRegion(region)"
          >
            <mat-icon class="explorer-chevron" [class.expanded]="region.visible" aria-hidden="true">
              {{ region.visible ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
            </mat-icon>
            <span class="explorer-label">{{ region.name }}</span>
            <select class="consequence-map-list-item-select" [(ngModel)]="region.consequenceId" (click)="$event.stopPropagation()" (change)="handleSelectConsequenceRegion(region)">
              <option *ngFor="let item of consequenceItems" [value]="item.id">
                {{ item.name }}
              </option>
              <!-- Default option using the first item's ID -->
              <option hidden *ngIf="consequenceItems.length > 0" [value]="defaultRegionSelectValue">
                {{ consequenceItems[0].name }}
              </option>
            </select>
          </div>
          <ul class="consequence-map-list section-list" *ngIf="region.visible">
            <li 
              class="consequence-map-list-item section-item"
              [ngClass]="{ 'consequence-map-list-item-data-selected': section == currentSelectedItem }"
              [class.consequence-map-list-item-data-ancestor]="currentSelectedItem && currentSelectedItem !== section && currentSelectedItem.regionId === region.regionId && currentSelectedItem.sectionId === section.sectionId"
              *ngFor="let section of region.sections"
            >
              <div class="consequence-map-list-item-data explorer-row section-row" (click)="handleClickSection(region, section)">
                <mat-icon class="explorer-chevron" [class.expanded]="section.visible" aria-hidden="true">
                  {{ section.visible ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                </mat-icon>
                <span class="explorer-label">{{ section.name }}</span>
                <select 
                  class="consequence-map-list-item-select" 
                  [(ngModel)]="section.consequenceId" 
                  (click)="$event.stopPropagation()" 
                  (change)="handleSelectConsequenceSection(section, $any($event.target).value)"
                >
                  <option *ngFor="let item of consequenceItems" [value]="item.id">
                    {{ item.name }}
                  </option>
                  <option [value]="defaultSectionSelectValue">
                    As in region
                  </option>
                </select>
              </div>
              <ul class="consequence-map-list element-list" *ngIf="section.visible">
                <li 
                  class="consequence-map-list-item element-item"
                  [ngClass]="{ 'consequence-map-list-item-data-selected': element == currentSelectedItem }" 
                  *ngFor="let element of section.elements"
                >
                  <div class="consequence-map-list-item-data explorer-row element-row" [disabled]="isLoadingStructure" (click)="handleClickElement(region, section, element)">
                    <span class="explorer-chevron-spacer" aria-hidden="true"></span>
                    <span class="explorer-label">{{ element.name }}</span>
                    <select class="consequence-map-list-item-select" [(ngModel)]="element.consequenceId" (click)="$event.stopPropagation()" (change)="handleSelectConsequenceElement(element)">
                      <option *ngFor="let item of consequenceItems" [value]="item.id">
                        {{ item.name }}
                      </option>
                      <option [value]="defaultElementSelectValue">
                        As in section
                      </option>
                    </select>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>

      <!-- No results message for region mode -->
      <div *ngIf="!isSectionMode && filteredRegions.length === 0 && searchTerm.trim() !== ''" class="no-results-message">
        <p>No regions found matching "{{ searchTerm }}"</p>
      </div>

      <div *ngIf="isSectionMode" class="consequence-map-section-mode">
        <div class="section-mode-info">
          <p><small>In section mode, you can set consequences for entire sections across all regions. Multi-consequence sections will show which regions have different consequences.</small></p>
        </div>
        
        <ul class="consequence-map-list">
          <li 
            class="consequence-map-list-item"
            *ngFor="let sectionItem of filteredSectionOnlyView"
          >
            <div class="consequence-map-list-item-data explorer-row section-mode-row" (click)="handleClickSectionMode(sectionItem)">
              <mat-icon
                *ngIf="sectionItem.hasMultipleConsequences"
                class="explorer-chevron"
                [class.expanded]="expandedSectionId === sectionItem.sectionId"
                aria-hidden="true"
              >
                {{ expandedSectionId === sectionItem.sectionId ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
              </mat-icon>
              <span *ngIf="!sectionItem.hasMultipleConsequences" class="explorer-chevron-spacer" aria-hidden="true"></span>

              <div class="section-mode-content">
                <div class="section-name">{{ sectionItem.name }}</div>

                <!-- Region count info -->
                <div class="section-region-count">
                  <small>{{ sectionItem.instances.length }} region(s)</small>
                  <small *ngIf="sectionItem.hasMultipleConsequences" class="different-regions-indicator">
                    - {{ sectionItem.consequenceAnalysis.differentRegions.length }} different
                  </small>
                </div>
              </div>

              <!-- Consequence selector -->
              <select
                class="consequence-map-list-item-select"
                [(ngModel)]="sectionItem.effectiveConsequenceId"
                (ngModelChange)="handleSelectConsequenceSectionMode(sectionItem, $event)"
                (click)="$event.stopPropagation()"
              >
                <option
                  *ngFor="let item of consequenceItems"
                  [ngValue]="item.id"
                >
                  {{ item.name }}
                </option>

                <option *ngIf="sectionItem.hasMultipleConsequences" [ngValue]="'MULTI_CONSEQUENCE'">
                  Multiple Consequences – Select to change all
                </option>
              </select>
            </div>

            <!-- Show regions with different consequences when expanded -->
            <div *ngIf="expandedSectionId === sectionItem.sectionId && sectionItem.hasMultipleConsequences" class="different-regions-list">
              <!-- Show majority consequence info -->
              <ul class="different-regions-items" *ngIf="sectionItem.consequenceAnalysis.majorityInfo">
                <li class="different-region-item majority-consequence-item">
                  <span class="region-name">Most regions ({{ sectionItem.consequenceAnalysis.majorityInfo.count }}):</span>
                  <span class="region-consequence">{{ sectionItem.consequenceAnalysis.majorityInfo.consequenceName }}</span>
                </li>
              </ul>
              
              
              <div class="different-regions-header">
                <small><strong>Regions with different consequences:</strong></small>
              </div>
              <ul class="different-regions-items">
                <li *ngFor="let region of sectionItem.consequenceAnalysis.differentRegions" class="different-region-item different-consequence-item">
                  <span class="region-name">{{ region.regionName }}</span>
                  <span class="region-consequence">{{ region.consequenceName }}</span>
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <!-- No results message for section mode -->
        <div *ngIf="filteredSectionOnlyView.length === 0 && searchTerm.trim() !== ''" class="no-results-message">
          <p>No sections found matching "{{ searchTerm }}"</p>
        </div>
      </div>
    </div>
  </div>
  <div content class="consequence-map-loading" *ngIf="isLoadingComponentData">
    <mat-spinner style="margin:auto; transform: scale(0.5);"></mat-spinner>
  </div>
</phdsoft-sideboard>
